import ReactDomServer from 'react-dom/server'
import React from 'react'

let staticData = {
  MaxxiaData: {
    RRPTooltip:
      'The #vehicleDescription# can be acquired for less than the cost of the Recommended Retail Price of #retailPrice# by taking advantage of Maxxia’s fleet buying power and discounts, as well as the potential GST savings.',
    CarPriceIncluded:
      '(Included first year registration, stamp duty & CTP if applicable)',
    DrivingHomeTitle: 'Driving home potential upfront savings',
    UpfrontSaving:
      'We’ve estimated you’ll save #saving# before you even start the ignition. Because, when it comes to cars, novated leasing helps you save money where you’d usually pay GST (on things like accessories, or even the listed price on new cars).',
    DriveAwaySaving: 'YOUR DRIVEAWAY GST SAVINGS #saving#',
    TotalPackageLine2: 'Ongoing running costs',
    EverythingAccordion:
      'This amount covers everything from your car’s finance to your running costs and is based on an annualised figure.',
    TotalPackageOngoing: 'Ongoing running costs',
    HowItWorks: (
      <>
        <strong>How it works: </strong>
        We take the kilometres you’ve estimated you’ll drive, and use them to
        put together a flexible budget that kicks bill shock to the kerb. Think
        you’ll drive more? You can adjust your kilometres with your consultant,
        and they’ll adjust your budget to cover the extra expenses. Drive less?
        Put whatever you haven’t spent towards future deductions, or we’ll pass
        it back once your lease wraps up.
        <br />
        <br />
        By paying for running costs from your salary before and after it gets
        taxed, you could save GST on all sorts of things. Like fuel, or even
        getting the car cleaned.
      </>
    ),
    HowItWorks_SAGBYO: (
      <>
        <strong>How it works: </strong>
        We take the kilometres you’ve estimated you’ll drive, and use them to
        put together a flexible budget that kicks bill shock to the kerb.
        <br />
        <br />
        By paying for running costs from your salary before and after it gets
        taxed, you could save GST on all sorts of things. Like fuel, or even
        getting the car cleaned.
      </>
    ),
    WhatIfIHaveMoneyLeft:
      'Once your lease has wrapped up, we’ll pass back whatever you didn’t spend in your budget. Your employer will then deduct income tax from this amount, before passing on the remaining balance to you.',
    WhatIfIHaveMoneyLeft_SAGBYO:
      'Once your lease has wrapped up, please contact your salary packaging provider to organise the balance in your account. Your employer will then deduct income tax from this amount, before passing on the remaining balance to you',
    NotIncluded:
      'A few things, like: road tolls, traffic infringements or accessories fitted to the car after your lease begins.',
    IncludesTheCar:
      'Includes your car, all accessories & on roads if applicable',
    WhyWantInsurances: (
      <>
        Because there’s bound to be a few unexpected turns in the next
        #leaseTermYears# years #firstName#.
        <br />
        <br /> Over the term of a lease, events can occur that are out of
        control. You could lose your job involuntarily or an unexpected hail
        storm could write off your car. In these circumstances LPI or TLA could
        provide you with assistance to minimise the financial impact of these
        events.
      </>
    ),
    ResidualValue:
      'At the end of your lease you can upgrade to a new car and new lease (and use the trade-in value to cover all or part of the residual); potentially reduce the residual value by re-leasing your car for a further lease term; or pay it.',
    EstSummSheetFootnotev1: (
      <>
        For finance arranged by Maxxia, Maxxia may receive commissions based on
        the total amount financed from the finance provider.
        <br />
        <br />
        For Insurance products, Maxxia may also complete services on behalf of
        the insurer including all claims management and policy administration
        that are in addition to selling the product. In these circumstances
        Maxxia can be paid a fee that is separate to the commission. All fees
        earned for services in addition to commission are included in the
        Financial Services Guide which you receive as part of the quoting and
        proposal process. <br />
        <br />
        Maxxia may also receive commissions and/or rebates in relation to some
        of the services provided to you through the life of your lease such as
        Roadside Assist, fleet fuel cards, tyres and windscreens provided by
        Maxxia preferred suppliers. In exchange for the administration of
        national fleet pricing and quoting services Maxxia provides to its
        preferred dealer network Maxxia may receive a commission.
        <br />
        <br />
        The costs of Maxxia optional aftercare products includes installation
        costs, warranty charges and may include profit to Maxxia.
        <br />
        <br />
        The Novated Lease Management Fee is included in the Scheduled Servicing
        budget included in the estimated vehicle running costs section.
      </>
    ),
    EstSummSheetFootnotev2: (
      <>
        In exchange for the administration of national fleet pricing and quoting
        services Maxxia provides to its preferred dealer network Maxxia may
        receive a commission.
        <br />
        <br />
        Maxxia may also receive commissions and/or rebates in relation to some
        of the services provided to you through the life of your lease such as
        Roadside Assist, fleet fuel cards, tyres and windscreens provided by
        Maxxia preferred suppliers.
        <br />
        <br />
        The costs of Maxxia optional aftercare products includes installation
        costs, warranty charges and may include profit to Maxxia.
      </>
    ),
    EstSummSheetFootnotev3: (
      <>
        For finance arranged by Maxxia, Maxxia may receive commissions based on the total amount financed from the finance provider.
      </>
    ),
    SellOtherCarUpgrade: (
      <>
        You bet. If you want to relive that new car feeling once your lease is
        up, we'll make upgrading easy. Our team will help you trade in the car
        on your current lease, and get you inside a new one ASAP.
        <br />
        <br />
        Or, if you decide to pay out the car, we can help you sell it to cover
        part (if not all) of the residual.
      </>
    ),
    RegoAndInsurance:
      'Includes the car’s registration and renewing your Comprehensive Insurance.',
  },
  RemServData: {
    RRPTooltip:
      'The #vehicleDescription# could be acquired for less than the cost of the Estimated Total Retail Price of #retailPrice# due to the potential GST savings and RemServ’s fleet buying power and discounts.',
    CarPriceIncluded:
      'Included first year registration, stamp duty & CTP if applicable',
    DrivingHomeTitle: 'Driving home your upfront savings',
    UpfrontSaving:
      'We’ve estimated you’ll save #saving# before you even start the ignition. Because, when it comes to your driveaway price, novated leasing helps you save money where you’d usually pay GST (on things like the listed price, or even your accessories).',
    DriveAwaySaving: 'YOUR GST SAVINGS upfront #saving#',
    TotalPackageLine2: 'On the road budget',
    EverythingAccordion:
      'This amount covers everything from the car’s finance to your running costs and is estimated based on an annualised figure.',
    TotalPackageOngoing: 'On the road budget',
    HowItWorks: (
      <>
        We take the kilometres you’ve estimated you’ll drive, and use them to
        put together a flexible budget that kicks bill shock to the kerb. Think
        you’ll drive more? You can adjust your kilometres with your consultant,
        and they’ll adjust your budget to cover the extra expenses.
        <br />
        <br />
        Drive less? Put whatever you haven't spent towards future deductions, or
        we'll pass it back once your lease wraps up. By paying for running costs
        from your salary before and after it gets taxed, you could save GST on
        all sorts of things. Like fuel, or even getting the car cleaned.
      </>
    ),
    WhatIfIHaveMoneyLeft:
      'Once your lease has wrapped up, we’ll pass whatever you didn’t spend in your budget back to your salary packaging provider. Your employer will then deduct income tax from this amount, before passing on the remaining balance to you.',
    NotIncluded:
      'A few things, like: road tolls, traffic infringements or accessories fitted to the car after your lease begins. Please ensure you contact your consultant prior to adding accessories fitted after the purchase date, as this may affect your lease.',
    IncludesTheCar:
      'Includes the car, first year registration, stamp duty & CTP if applicable.',
    WhyWantInsurances: (
      <>
        Because there’s bound to be a few unexpected turns in the next
        #leaseTermYears# years #firstName#. Say you lose your job before your
        lease is up? Lease Protection Insurance steps in. What if your car gets
        written-off by hail damage? Total Loss Assist has your back. <br />
        <br />
        By choosing to include insurances on your lease, you could protect
        yourself from those incidents out of your control.
      </>
    ),
    ResidualValue:
      'Thanks to your residual, novated leasing helps you keep money in your pocket upfront. When your lease is up, you’ll owe the residual value. You can roll your residual into a new lease, make it smaller by re-leasing the car, or pay it out. We’ve calculated it for you upfront, just to make sure there are no surprises down the road.',
    EstSummSheetFootnotev1: (
      <>
        RemServ may also receive commissions and/or rebates in relation to some
        of the services provided to you through the life of your lease such as
        Roadside Assist, fleet fuel cards, tyres and windscreens provided by
        RemServ preferred suppliers.
        <br />
        <br />
        In exchange for the administration of national fleet pricing and quoting
        services RemServ provides to its preferred dealer network RemServ may
        receive a commission.
        <br />
        <br />
        The costs of RemServ's optional aftercare products includes installation
        costs, warranty charges and may include profit to RemServ.
      </>
    ),
    EstSummSheetFootnotev2: null,
    EstSummSheetFootnotev3: null,
    SellOtherCarUpgrade: (
      <>
        You bet. If you want to relive that new car feeling once your lease is
        up, we'll make upgrading easy. Our team will help you trade in the car
        on your current lease, and get you inside a new one ASAP.
        <br />
        <br />
        Or, if you decide to pay out the car, we can help you sell it to cover
        part (if not all) of the residual. This is an optional service provided
        by RemServ. You are not required to use this service to help sell your
        car if you upgrade.
      </>
    ),
    RegoAndInsurance:
      'Includes your renewals for registration and Comprehensive Insurance.',
  },
}

const elementHolderReplace = (args, content) => {
  let stringContent = ReactDomServer.renderToString(content)
  stringContent = stringHolderReplace(args, stringContent)

  return <div dangerouslySetInnerHTML={{ __html: stringContent }} />
}

const stringHolderReplace = (args, content) => {
  let stringContent = content
  let keys = Object.keys(args)
  keys.forEach((arg) => {
    stringContent = stringContent.replace(
      new RegExp(`#${arg}#`, 'g'),
      args[arg]
    )
  })
  return stringContent
}

export const EstimateDetailStaticData = (prop, args) => {
  let data
  if (global.config.isBrandMX) data = staticData.MaxxiaData
  else if (global.config.isBrandRS) data = staticData.RemServData

  let content = data[prop]
  if (args) {
    if (React.isValidElement(content)) {
      content = elementHolderReplace(args, content)
    }
    if (typeof content == 'string') {
      content = stringHolderReplace(args, content)
    }
  }
  return content
}
